export const UserForm = ({children, ...rest}) => {
  return <form {...rest} >{children}</form>
}
